export default class ConversationUploadModel {
  id!: number;

  mediaId!: string;

  path!: string;
}
